import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type CategoryFileFragment = { id: string, name: string, purpose?: Types.FilePurposeEnum | null, childrenIds?: Array<string> | null, category: Types.FileCategoryEnum, contentCount?: number | null, subWorkspaces?: Array<string> | null };


export type CategoryFileFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const CategoryFileFragmentDoc = /*#__PURE__*/ gql`
    fragment CategoryFile on FileSchema {
  id
  name
  purpose
  childrenIds
  category
  contentCount
  subWorkspaces
}
    `;